import React, { Component } from 'react';
import PortalDropdown from '../../../portal/portalDropdown';
export default class GroupMembersAttributeOriginDropdownContainer extends Component {
  
constructor(props){
    super(props);

    this.groupMembersAttributeSourceOptions = [];
    this.groupMembersAttributeSourceId = 0;
}

	componentWillMount() {
    
    this.groupMembersAttributeSourceOptions = this.props.groupMembersAttributeSourceItems.map((x, index) =>  ({ 
        id: index,
        name: x 
    }));
}

setSelectedValue(){

    let selectedValue = this.props.groupMembersAttributeSourceItems.find(
        x => this.props.groupMembersAttributeSource.toLowerCase() == x.toLowerCase());
    this.groupMembersAttributeSourceId = selectedValue ? 
        this.props.groupMembersAttributeSourceItems.indexOf(selectedValue) : 0;
}

render() {

    this.setSelectedValue();

    return (
        <PortalDropdown
            {...this.props}
            dataCy='dd-group-member-attribute-source'
            width='47%'
            value={this.groupMembersAttributeSourceId}
            items={this.groupMembersAttributeSourceOptions}            
        />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ldap/forms/groupMembersAttributeOriginDropdownContainer/index.jsx